import React, { useState, useEffect, useRef } from "react";
import { Box, Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";

import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import { getAuth } from "firebase/auth";
import { db, storage } from "../../firebase";
import { collection, getDoc, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function AiMemberEdit() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [param, setParam] = useState("");
    const [existance, setExistance] = useState(false);

    const [imgUrl, setImgUrl] = useState("");
    const [imgUrlOverrap, setImgUrlOverrap] = useState("");
    const [name, setName] = useState("");
    const [desc, setDesc] = useState("");

    const [avaterOpen, setAvaterOpen] = useState(false);
    const fileInputRef = useRef(null);
    const [imgSrc, setImgSrc] = useState(null);
    const [croppedImgSrc, setCroppedImgSrc] = useState("");
    const [cropper, setCropper] = useState(null);

    const handleAvaterOpen = () => {
        fileInputRef.current.value = "";
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const files = event.target.files;
        if (files) {
            setAvaterOpen(true);
            const reader = new FileReader();
            reader.onload = () => {
                setImgSrc(reader.result);
            };
            reader.readAsDataURL(files[0]);
        }
    };

    const onCropperInit = (instance) => {
        setCropper(instance);
    };

    // トリミングする
    const handleCrop = () => {
        if (cropper) {
            const canvas = cropper.getCroppedCanvas();
            const dataUrl = canvas.toDataURL();
            setImgUrl(dataUrl);
            setCroppedImgSrc(canvas);
        }
        handleCancel();
    };

    // トリミングをキャンセルする
    const handleCancel = () => {
        setAvaterOpen(false);
        setImgSrc(null);
    };

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handleDescChange = (event) => {
        setDesc(event.target.value);
    };

    const handleUpdateClick = async () => {
        if (imgUrl === imgUrlOverrap) {
            saveTofirestoreSameImg();
        } else if (imgUrl) {
            const strageRef = ref(storage, `aiMember/${param}`);

            const blob = await new Promise((resolve) => {
                croppedImgSrc.toBlob((blob) => resolve(blob));
            });

            try {
                await uploadBytes(strageRef, blob);
                const url = await getDownloadURL(strageRef);
                saveToFirestore(url);
            } catch (error) {
                console.error("Error uploading img: ", error);
            }
        } else {
            saveToFirestoreNotImg();
        }
    };

    const saveTofirestoreSameImg = async () => {
        try {
            const documentRef = doc(db, "aiMember", param);
            await updateDoc(documentRef, {
                name: name,
                desc: desc,
                updateAt: serverTimestamp(),
            });
        } catch (error) {
            console.log("error: ", error);
        }

        setSaveOpen(true);
    };

    const saveToFirestore = async (url) => {
        try {
            const documentRef = doc(db, "aiMember", param);
            await updateDoc(documentRef, {
                img: url,
                name: name,
                desc: desc,
                updateAt: serverTimestamp(),
            });
        } catch (error) {
            console.error("error: ", error);
        }

        setSaveOpen(true);
    };

    const saveToFirestoreNotImg = async () => {
        try {
            const documentRef = doc(db, "aiMember", param);
            await updateDoc(documentRef, {
                img: "",
                name: name,
                desc: desc,
                updateAt: serverTimestamp(),
            });
        } catch (error) {
            console.error("error: ", error);
        }

        setSaveOpen(true);
    };

    const [saveOpen, setSaveOpen] = useState(false);
    const handleSaved = () => {
        window.scrollTo(0, 0);
        navigate("/", { replace: true });
    };

    const fetchUserData = async () => {
        const params = window.location.pathname.split("/")[2];
        setParam(params);

        const memberRef = collection(db, "aiMember");
        const memberDoc = doc(memberRef, params);
        const memberSnapshot = await getDoc(memberDoc);

        if (memberSnapshot.exists()) {
            setImgUrl(memberSnapshot.data().img);
            setImgUrlOverrap(memberSnapshot.data().img);
            setName(memberSnapshot.data().name);
            setDesc(memberSnapshot.data().desc);
            setExistance(true);
        } else {
            setExistance(false);
        }

        setLoading(false);
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                await fetchUserData();
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>ai Member Edit - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                {existance ? (
                    <Container>
                        <Box
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                            sx={{ mt: 10 }}
                        >
                            <Typography variant="h6">AIメンバー情報編集</Typography>
                        </Box>

                        <Box
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                            sx={{ m: 3 }}
                        >
                            <Box
                                sx={{
                                    minWidth: 350,
                                    minHeight: 350,
                                    border: "1px solid",
                                    borderColor: "primary.main",
                                    borderRadius: 1,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                                onClick={handleAvaterOpen}
                            >
                                <input type="file" accept="image/*" style={{ display: "none" }} onChange={handleFileChange} ref={fileInputRef} />

                                {imgUrl ? (
                                    <img
                                        src={imgUrl}
                                        alt="uploaded"
                                        style={{
                                            maxWidth: 348,
                                            maxHeight: 348,
                                        }}
                                    />
                                ) : (
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                            color: "text.secondary",
                                        }}
                                        type="file"
                                        onChange={handleAvaterOpen}
                                    >
                                        画像をアップロード
                                    </Box>
                                )}
                            </Box>
                        </Box>

                        <Box
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                            sx={{ m: 3 }}
                        >
                            <TextField variant="filled" label="名前" value={name} onChange={handleNameChange} sx={{ minWidth: 350 }} />
                        </Box>

                        <Box
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                            sx={{ m: 3 }}
                        >
                            <TextField
                                variant="filled"
                                label="プロフィール"
                                value={desc}
                                onChange={handleDescChange}
                                multiline
                                rows={5}
                                sx={{ minWidth: 350 }}
                            />
                        </Box>

                        <Box
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                            sx={{ mt: 5, mb: 2 }}
                        >
                            <Button variant="contained" onClick={handleUpdateClick} size="large" sx={{ width: "350px" }}>
                                更新
                            </Button>
                        </Box>
                    </Container>
                ) : (
                    <div>
                        <Typography
                            sx={{ mt: 10, mb: 2 }}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            404 Not Found
                        </Typography>
                    </div>
                )}
            </Container>

            <Dialog open={saveOpen}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    更新しました
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", display: "flex", mb: 2 }}>
                    <Button variant="contained" sx={{ width: "100px" }} onClick={handleSaved}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={avaterOpen} onClose={handleCancel}>
                <DialogTitle
                    sx={{
                        minWidth: 330,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    トリミング
                </DialogTitle>
                <DialogContent>
                    {imgSrc && (
                        <Box>
                            <Cropper
                                src={imgSrc}
                                style={{ height: 350, width: "100%" }}
                                initialAspectRatio={1}
                                cropBoxMovable={false}
                                cropBoxResizable={false}
                                guides={false}
                                dragMode="move"
                                onInitialized={(instance) => onCropperInit(instance)}
                            />
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleCancel}>
                        キャンセル
                    </Button>
                    <Button onClick={handleCrop} variant="contained">
                        切り抜く
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default AiMemberEdit;
